import React from "react";

export default function AWS_Personalize() {
  return (
    <div>
      <h1>What is AWS Personalize</h1>
      <p>
        Route: <code>/aws/personalize</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
